import request from '@/lib/request.mjs';

export default function ({ accountId }) {
  return request('getPhoneAccount', { accountId });
}
